import type { LucideIcon } from "lucide-react";

interface EmptyStateProps {
  icon: LucideIcon;
  title: string;
  description: string;
}

/** Renders the icon and explanatory copy for an empty collection. */
export const EmptyState = ({
  icon: Icon,
  title,
  description,
}: EmptyStateProps) => {
  return (
    <div className="flex min-h-[260px] flex-col items-center justify-center px-6 py-10 text-center">
      <div className="mb-5 flex size-12 items-center justify-center rounded-xl border bg-background text-primary">
        <Icon className="size-6" />
      </div>
      <h3 className="text-[17px] font-medium text-foreground">{title}</h3>
      <p className="mt-2 text-sm text-muted-foreground">{description}</p>
    </div>
  );
};
